module.exports = __webpack_public_path__ + "img/24000.d182b36c.jpg";